<template>
  <div class="d-flex mb-2">
    <div class="activity-progress-bar__icon">
      <small>
        <slot name="icon">
          <font-awesome-icon :icon="icon" />
        </slot>
      </small>
    </div>
    <div class="w-100">
      <div class="d-flex justify-content-between">
        <div>
          <small>{{ label }}</small>
        </div>
        <div>
          <small>{{ progress }}</small>
        </div>
      </div>
      <BaseProgressBar
        :max="max"
        :current="progress"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityBaseProgressBar',
  props: {
    icon: {
      default: 'envelope',
    },
    label: {
      type: String,
      default: 'label',
    },
    max: {
      type: Number,
      required: false,
      default: 100,
    },
    progress: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.activity-progress-bar__icon{
    width: 1rem;
    margin-right: 0.75rem;
}
</style>
